console.log(process.env);

const getColors = client => {
  return {
    primaryColor: '#f0e600',
    primary2Color: '#666',
    complementaryColor: '#fff',
    labelColor: 'rgba(0,0,0,0.3)',
  };
};

const TOKEN_IDENTIFIER = '@ContentBackend:authToken';
const PROJECT_IDENTIFIER = '@ContentBackend:projectKey';

const getConfig = () => ({
  apiUrl: process.env.REACT_APP_API_URL,
  thumbBaseUrl: 'https://res.cloudinary.com/arkulpa/image/upload/c_limit,h_100,w_150/',
  getAuthHeader() {
    const authToken = localStorage.getItem(TOKEN_IDENTIFIER);
    return authToken ? `Bearer ${authToken}` : null;
  },
  getAuthToken() {
    return localStorage.getItem(TOKEN_IDENTIFIER);
  },
  removeAuthToken() {
    localStorage.removeItem(TOKEN_IDENTIFIER);
  },
  writeAuthToken(token) {
    localStorage.setItem(TOKEN_IDENTIFIER, token);
  },
  writeProjectKey(key) {
    localStorage.setItem(PROJECT_IDENTIFIER, key);
  },
  getProjectKey() {
    return localStorage.getItem(PROJECT_IDENTIFIER);
  },
  colors: getColors(),
  minutesStep: 5,
});
export default getConfig();



// WEBPACK FOOTER //
// ./src/config.js